import { InternalMessageType } from '@lib/internal-messages/enums';
import { InternalMessagePayloadValidator } from '@lib/internal-messages/types';

import { InternalAddToCartResponsePayload } from './types';

export const internalAddToCartResponsePayloadValidator: InternalMessagePayloadValidator<
    InternalMessageType.AddToCartResponse
> = (payload: unknown): payload is InternalAddToCartResponsePayload =>
    !!payload &&
    typeof payload === 'object' &&
    'success' in payload &&
    typeof payload.success === 'boolean' &&
    (payload.success
        ? 'cartUrl' in payload
            ? typeof payload.cartUrl === 'string' ||
              typeof payload.cartUrl === 'undefined'
            : true
        : 'error' in payload
          ? typeof payload.error === 'string' ||
            typeof payload.error === 'undefined'
          : true);
